<template>
  <v-combobox
    v-model="filterOptions"
    ref="combobox"
    :items="availableOptions"
    :item-text="showLogicalLanguage ? 'prolog' : 'name'"
    item-value="id"
    :label="$t(label)"
    multiple
    allow-overflow
    outlined
    :search-input.sync="search"
    @change="onChange"
    @focus="menuOpen = true"
    @blur="menuOpen = false"
    @click:clear="onChange(filterOptions)"
    hide-details
    :disabled="disabled"
    auto-select-first
    :menu-props="{ value: menuOpen }"
  >
    <template v-slot:selection="data">
      <v-progress-circular
        v-if="isString(data.item) && data.item.trim().length !== 0"
        color="grey lighten-2"
        indeterminate
      />
      <option-chip-2
        v-else-if="!isString(data.item)"
        :option="data.item"
      />
    </template>

    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title>
          <v-list-item-action>
            <v-icon v-if="data.attrs.inputValue">mdi-checkbox-marked</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-action>
          <option-chip-2
            :option="data.item"
          />
        </v-list-item-title>
      </v-list-item-content>
    </template>

    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            No results matching "<strong>{{ search }}</strong>".
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template v-slot:append>
      <v-row no-gutters>
        <v-icon class="ml-1" :class="{ 'primary--text': menuOpen }" @click.prevent="filterOptions = availableOptions">mdi-check-all</v-icon>
        <v-icon class="ml-1" :class="{ 'primary--text': menuOpen }" @click.prevent="filterOptions = []">mdi-close</v-icon>
        <v-icon class="ml-1" v-if="menuOpen" @click.stop="menuOpen = false">mdi-menu-up</v-icon>
        <v-icon class="ml-1" v-else @click.stop="menuOpen = true;$refs.combobox.$refs.input.focus()">mdi-menu-down</v-icon>
      </v-row>
    </template>
  </v-combobox>
</template>

<script>
import OptionChip2 from "@/components/global/OptionChip2"
import naturalOrLogicalLanguageMixin from '@/mixins/natural-or-logical-language-mixin.js';

export default {
  name: "InputOptions",

  components: { OptionChip2 },

  mixins: [ naturalOrLogicalLanguageMixin ],

  data() {
    return {
      menuOpen: false,
      projectId: this.$route.params.id,
      search: null,
    };
  },

  props: {
    availableOptions: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: 'play.filterByOptions'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    filterOptions: {
      get () {
          return this.options;
      },
      set (value) {
          this.$emit('update:options', value);
      }
    },
  },

  watch: {
    filterOptions(val, prev) {
      if (val.length === prev.length) {
        return
      }
      else {
        this.filterOptions = val.filter(v => !this.isString(v))
      }
    },
  },

  methods: {
    onChange(options) {
      // console.log('onChange', scenario)
      this.search = null
      this.$emit('options-selected', options)
    },

    isString(value) {
      return typeof value === "string" && value.trim().length > 0
    },
  },

};
</script>
<style scoped>
  .ise-modal-delete-title {
    margin-right: 5px;
  }
</style>